import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from './ui/Card';
import { ArrowRight } from 'lucide-react';
interface CategoryCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  href: string;
}
export function CategoryCard({
  title,
  description,
  icon,
  href
}: CategoryCardProps) {
  return <Link to={href} className="block h-full" data-id="element-28">
      <Card hover className="h-full p-6 flex flex-col items-start group" data-id="element-29">
        <div className="mb-6 p-3 bg-[#f0f9ff] rounded-lg text-[#0af] group-hover:bg-[#0af] group-hover:text-white transition-colors duration-300" data-id="element-30">
          {icon}
        </div>
        <h3 className="text-xl font-bold text-[#022a3b] mb-3 group-hover:text-[#0af] transition-colors" data-id="element-31">
          {title}
        </h3>
        <p className="text-gray-600 mb-6 flex-grow leading-relaxed" data-id="element-32">
          {description}
        </p>
        <div className="flex items-center text-[#0af] font-medium text-sm group-hover:translate-x-1 transition-transform" data-id="element-33">
          Ver artículos <ArrowRight className="ml-2 h-4 w-4" data-id="element-34" />
        </div>
      </Card>
    </Link>;
}